import * as React from "react";
const SvgFiBrandsDailymotion = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      fillRule="evenodd"
      d="M16.066 1.043v7.523c-1.141-1.48-2.711-2.184-4.756-2.184-2.164 0-4.09.801-5.66 2.378-1.76 1.723-2.71 3.956-2.71 6.431 0 2.718.999 5.023 2.949 6.795C7.363 23.321 9.147 24 11.192 24c2.02 0 3.543-.534 5.017-2.014v1.941h4.85V0zm-3.757 18.395c-2.544 0-4.375-1.844-4.375-4.271 0-2.305 1.83-4.271 4.185-4.271 2.33 0 4.138 1.869 4.138 4.344-.001 2.378-1.784 4.198-3.948 4.198"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFiBrandsDailymotion;
